import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling
import 'tippy.js/themes/light-border.css'

tippy('[data-tippy-content]', { theme: 'light-border' })
